import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-applicationdiv',
  templateUrl: './applicationdiv.component.html',
  styleUrls: ['./applicationdiv.component.scss']
})
export class ApplicationdivComponent {


  @Input() appItem: any;
  constructor() { }


  onImgError($event) {
    $event.target.src = 'assets/theme/mclane/img/mclane-color.png';
  }

}
